<template>
  <v-dialog
    persistent
    max-width="600"
    content-class="modal-alert"
    value="visible"
  >
    <v-card>
      <v-container
        fluid
        class="text-center d-flex flex-column justify-center align-center pa-8 pt-4"
      >
        <p class="headline font-weight-bold navy-dark--text mt-6 mb-6">
          <slot name="title" />
        </p>
        <p class="title navy-medium--text mb-6">
          <slot name="sub-header" />
        </p>
        <p class="body-2 navy-medium--text mb-6">
          <slot name="message" />
        </p>
        <v-card-actions
          class="mt-4"
          :class="$vuetify.breakpoint.mdAndDown ? 'flex-column' : undefined"
        >
          <v-btn
            v-if="cancel"
            x-large
            rounded
            class="pl-4 pr-4 mt-2"
            @click="$emit('cancel')"
          >
            <slot name="cancelText">Cancel</slot>
          </v-btn>
          <v-btn
            x-large
            color="primary"
            class="pl-8 pr-8 mt-2"
            rounded
            @click="$emit('success')"
          >
            <slot name="confirmText">Confirm</slot>
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'modal-alert',
  props: {
    cancel: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
